import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { Screen } from "@/shared/v2/queries/interfacesV2";
import { useQuery } from "@tanstack/react-query";

const useScreensQuery = () => {
  const branch = useBranchId();

  const query = useQuery<Screen[]>({
    queryKey: ["screens", branch],
    queryFn: () => get2(`/internal/secure/pos/v1/kitchens/screens/${branch}`),
  });

  return query;
};

export default useScreensQuery;
